module.exports = __webpack_public_path__ + "static/media/check-card.e795a595.svg";